import React, { useEffect, useState } from "react";
import { LabelHLPure, InputHLPure, PhoneInputHLPure, ButtonHLPure, ArrowBtnHLPure, ButtonGreyHLPure, DropDownBtnHLPure } from "../../pures";
import { Container, Grid } from '@material-ui/core'
import { Avatar } from "@progress/kendo-react-layout";
import "./profile-administration-principal-view.css"

const ProfileAdministrationPrincipalView = (props) => {
    let {
        t,
        userPathImage,
        handleImage,
        userMail,
        firstName,
        firstLastName,
        secondLastName,
        preferredLanguage,
        clientId,
        cellphoneNumber,
        phoneNumber,
        rfc,
        curp,
        validator,
        updateUser,
        selectOtherView,
        history,
        languages
    } = props

    const [userName, setUserName] = useState('')
    const [userFirstLastName, setUserFirstLastName] = useState('')
    const [userSecondLastName, setUserSencondLastName] = useState('')
    const [userPreferredLanguage, setUserPreferredLanguage] = useState('')
    const [userCellPhoneNuber, setUserCellPhoneNumber] = useState('')
    const [userPhoneNumber, setuserPhoneNumber] = useState('')
    const [userRFC, setUserRFC] = useState('')
    const [userCURP, setUserCURP] = useState('')

    const [errorInputName, setErrorInputName] = useState(false)
    const [errorInputTextName, setErrorInputTextName] = useState('')
    const [errorInputFirstLastName, setErrorInputFirstLastName] = useState(false)
    const [errorInputTextFirstLastName, setErrorInputTextFirstLastName] = useState('')
    const [errorInputSecondLastName, setErrorInputSecondLastName] = useState(false)
    const [errorInputTextSecondLastName, setErrorInputTextSecondLastName] = useState('')

    const [errorInputCellPhone, setErrorInputCellphone] = useState(false)
    const [errorInputTextCellphone, setErrorInputTextCellphone] = useState('')
    const [errorInputRFC, setErrorInputRFC] = useState(false)
    const [errorInputTextRFC, setErrorInputTextRFC] = useState('')
    const [errorInputCURP, setErrorInputCURP] = useState(false)
    const [errorInputTextCURP, setErrorInputTextCURP] = useState('')
    const [errorInpuPhone, setErrorInputPhone] = useState(false)
    const [errorInputTextPhone, setErrorInputTextPhone] = useState('')

    useEffect(() => {
        if (!clientId || clientId === 0) return
        setUserName(firstName)
        setUserFirstLastName(firstLastName)
        setUserSencondLastName(secondLastName)
        setUserPreferredLanguage(preferredLanguage)
        setUserCellPhoneNumber(cellphoneNumber)
        setuserPhoneNumber(phoneNumber)
        setUserRFC(rfc)
        setUserCURP(curp)
    }, [clientId])

    const onChangeInputs = (e, setValue, setError, setErrorText) => {
        let value = e.target.value
        setValue(value)

        if (setError, setErrorText) {
            setError(false)
            setErrorText('')
        }
    }

    const onChangeCellphone = (phoneNumber, setValue, setError, setErrorText) => {
        setValue(phoneNumber)

        if (setError, setErrorText) {
            setError(false)
            setErrorText('')
        }
    }

    const saveData = () => {
        let name = (userName) ? userName.trim() : ''
        let firstLastName = (userFirstLastName) ? userFirstLastName.trim() : ''
        let secondLastName = (userSecondLastName) ? userSecondLastName.trim() : ''
        let cellPhoneNumber = (userCellPhoneNuber) ? userCellPhoneNuber.trim() : ''
        let phoneNumber = (userPhoneNumber) ? userPhoneNumber.trim() : ''
        let rfc = (userRFC) ? userRFC.trim() : ''
        let curp = (userCURP) ? userCURP.trim() : ''

        let nameValidated = validator.nameValidator(name)
        let firstLastNameValidated = validator.firstLastNameValidator(firstLastName)
        let secondLastNameValidated = validator.secondLastNameValidator(secondLastName)
        let cellPhoneValidated = validator.phoneNumberValidator(cellPhoneNumber)
        let rfcValidated = validator.rfcValidator(rfc)
        let curpValidated = ''
        if (curp) {
            curpValidated = validator.curpValidator(curp)
        }

        if (!userName || !name || nameValidated !== '') {
            setErrorInputName(true)
            setErrorInputTextName(t("profile.validator.nameValidator"))
            return
        }

        if (!userFirstLastName || !firstLastName || firstLastNameValidated !== '') {
            setErrorInputFirstLastName(true)
            setErrorInputTextFirstLastName(t("profile.validator.firstLastNameValidator"))
            return
        }

        if (!userSecondLastName || !secondLastName || secondLastNameValidated !== '') {
            setErrorInputSecondLastName(true)
            setErrorInputTextSecondLastName(t("profile.validator.secondLastNameValidator"))
            return
        }

        if (!userCellPhoneNuber || !cellPhoneNumber || cellPhoneValidated !== '') {
            setErrorInputCellphone(true)
            setErrorInputTextCellphone(t("profile.validator.phoneNumberValidator"))
            return
        }

        if (cellPhoneNumber.length !== 3 && cellPhoneNumber.length !== 13 && cellPhoneNumber.length !== 10) {
            setErrorInputCellphone(true)
            setErrorInputTextCellphone(t("profile.validator.phoneNumberValidator"))
            return
        }

        if (phoneNumber && phoneNumber.length !== 3 && phoneNumber.length !== 13) {
            setErrorInputPhone(true)
            setErrorInputTextPhone(t("profile.validator.phoneNumberValidator"))
            return
        }

        if (rfcValidated !== '') {
            setErrorInputRFC(true)
            setErrorInputTextRFC(t("profile.validator.rfcValidator"))
            return
        }

        if (curpValidated !== '') {
            setErrorInputCURP(true)
            setErrorInputTextCURP(t("profile.validator.curpValidator"))
            return
        }

        let userData = {
            firstName: name,
            firstLastName,
            secondLastName,
            cellphoneNumber: cellPhoneNumber,
            phoneNumber: phoneNumber,
            rfc,
            curp,
            languageId: userPreferredLanguage
        }

        updateUser(userData)
    }

    const handleGoBack = () => {
        history.goBack()
    }

    const handleSendToFDA = () => {
        history.push({
            pathname: "/request-reliable-signature",
            state: { item: props }
        })
    }

    const toggleSignatureAutograph = () => {
        history.push({ pathname: "/request-base-signature" })
    };

    return (
        <Container>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="profileAdministrationPrincipalView-container"
            >
                <div className="profileAdministrationPrincipalView-body">
                    <LabelHLPure
                        text={t("profileAdministrationPrincipalView.label")}
                        fontSize={'14px'}
                        showTooltip={true}
                        positionTooltip={'right'}
                        titleTooltip={t("profileAdministrationPrincipalView.title.tooltip")}
                        descriptionTooltip={t("profileAdministrationPrincipalView.description.tooltip")}
                        informationIcon={true}
                    />
                    <div className="profileAdministrationPrincipalView-grid-data">
                        <div className="profileAdministrationPrincipalView-container-image">
                            <Avatar
                                shape="circle"
                                type="image"
                                className="profile-container-img"
                            >
                                <img
                                    src={userPathImage}
                                    alt="user image"
                                    className="k-avatar-image profile-img imageSizesStyles"
                                />
                            </Avatar>
                            <div className="profileAdministrationPrincipalView-container-btn">
                                <div className="custom-input-file-p profileAdministrationPrincipalView-btn-image"
                                    xs={8}
                                    lg={8}
                                    md={8}
                                    sm={8}
                                    es={8}
                                >
                                    <input
                                        className="input-file-p"
                                        type="file"
                                        accept="image/*"
                                        id="file"
                                        onClick={(e) => (e.target.value = null)}
                                        onChange={(e) => handleImage(e)}
                                    />
                                    {t("dialogUpdateUserAddress.tooltipButtonImageEdit")}
                                </div>
                            </div>
                        </div>
                        <div className="profileAdministrationPrincipalView-container-data">
                            <div className="profileAdministrationPrincipalView-container-email">
                                <InputHLPure
                                    labelInput={t("profileAdministrationPrincipalView.email")}
                                    valueInput={userMail}
                                    typeInput={"text"}
                                    inputActive={true}
                                    disabled={true}
                                />
                                <InputHLPure
                                    labelInput={t("profileAdministrationPrincipalView.name")}
                                    valueInput={userName}
                                    typeInput={"text"}
                                    handleChangeInput={(e) => onChangeInputs(e, setUserName, setErrorInputName, setErrorInputTextName)}
                                    inputActive={true}
                                    required
                                    errorInput={errorInputName}
                                    errorInputText={errorInputTextName}
                                />
                                <InputHLPure
                                    labelInput={t("profileAdministrationPrincipalView.firstLastName")}
                                    valueInput={userFirstLastName}
                                    typeInput={"text"}
                                    handleChangeInput={(e) => onChangeInputs(e, setUserFirstLastName, setErrorInputFirstLastName, setErrorInputTextFirstLastName)}
                                    inputActive={true}
                                    required
                                    errorInput={errorInputFirstLastName}
                                    errorInputText={errorInputTextFirstLastName}
                                />
                                <InputHLPure
                                    labelInput={t("profileAdministrationPrincipalView.secondLastName")}
                                    valueInput={userSecondLastName}
                                    typeInput={"text"}
                                    handleChangeInput={(e) => onChangeInputs(e, setUserSencondLastName, setErrorInputSecondLastName, setErrorInputTextSecondLastName)}
                                    inputActive={true}
                                    required
                                    errorInput={errorInputSecondLastName}
                                    errorInputText={errorInputTextSecondLastName}
                                />
                                {languages.length > 0 &&
                                    <DropDownBtnHLPure
                                        labelDropDown={t("profileAdministrationPrincipalView.preferredLanguage")}
                                        valueItem={"id"}
                                        optionsValue={userPreferredLanguage}
                                        onDropDownChange={(e) => onChangeInputs(e, setUserPreferredLanguage)}
                                        nameOption="name"
                                        optionsDropDown={languages}
                                    />
                                }
                                {/* <InputHLPure
                                    labelInput={t("profileAdministrationPrincipalView.preferredLanguage")}
                                    valueInput={userPreferredLanguage}
                                    typeInput={"text"}
                                    handleChangeInput={(e) => onChangeInputs(e, setUserPreferredLanguage)}
                                    inputActive={true}
                                    required
                                /> */}
                            </div>
                            <div className="profileAdministrationPrincipalView-container-phone">
                                <div className="profileAdministrationPrincipalView-phone">

                                    <PhoneInputHLPure
                                        labelInput={t("profileAdministrationPrincipalView.cellphone")}
                                        placeholder={t("profileAdministrationPrincipalView.phone.placeholder")}
                                        value={userCellPhoneNuber}
                                        onCellphoneChange={(phoneNumber) => onChangeCellphone(phoneNumber, setUserCellPhoneNumber, setErrorInputCellphone, setErrorInputTextCellphone)}
                                        defaultCountry={"MX"}
                                        international={true}
                                        countryCallingCodeEditable={false}
                                    />
                                    {errorInputCellPhone && (
                                        <span className="hint-message-error">{errorInputTextCellphone}</span>
                                    )
                                    }
                                </div>
                                <InputHLPure
                                    labelInput={t("profileAdministrationPrincipalView.rfc")}
                                    valueInput={userRFC}
                                    typeInput={"text"}
                                    handleChangeInput={(e) => onChangeInputs(e, setUserRFC, setErrorInputRFC, setErrorInputTextRFC)}
                                    inputActive={true}
                                    errorInput={errorInputRFC}
                                    errorInputText={errorInputTextRFC}
                                />
                                <div className="profileAdministrationPrincipalView-phone">
                                    <PhoneInputHLPure
                                        limitMaxLength
                                        labelInput={t("profileAdministrationPrincipalView.phone")}
                                        placeholder={t("profileAdministrationPrincipalView.phone.placeholder")}
                                        value={userPhoneNumber}
                                        onCellphoneChange={(phoneNumber) => onChangeCellphone(phoneNumber, setuserPhoneNumber, setErrorInputPhone, setErrorInputTextPhone)}
                                        defaultCountry={"MX"}
                                        international={true}
                                        countryCallingCodeEditable={false}
                                    />
                                    {errorInpuPhone && (
                                        <span className="hint-message-error">{errorInputTextPhone}</span>
                                    )
                                    }
                                </div>
                                <InputHLPure
                                    labelInput={t("profileAdministrationPrincipalView.curp")}
                                    valueInput={userCURP}
                                    typeInput={"text"}
                                    handleChangeInput={(e) => onChangeInputs(e, setUserCURP, setErrorInputCURP, setErrorInputTextCURP)}
                                    inputActive={true}
                                    errorInput={errorInputCURP}
                                    errorInputText={errorInputTextCURP}
                                />
                                <ButtonGreyHLPure
                                    labelBtn={props.fdaLabel}
                                    onClickBtn={() => handleSendToFDA()}
                                />
                                <ButtonGreyHLPure
                                    labelBtn={props.baseSignLabel}
                                    onClickBtn={() => toggleSignatureAutograph()}
                                />
                                {/* {t("profileAdministrationPrincipalView.btn.base.sign")}
                                {t("profileAdministrationPrincipalView.btn.fda")} */}
                            </div>
                        </div>
                    </div>
                    <div className="profileAdministrationPrincipalView-container-btns">
                        <div className="profileAdministrationPrincipalView-arrow-btns">
                            <ButtonHLPure
                                nameBtn={t("button.return")}
                                primary={false}
                                onClickBtn={() => handleGoBack()}
                            />
                        </div>
                        <div className="profileAdministrationPrincipalView-arrow-btns">
                            <ArrowBtnHLPure
                                textArrowBtn={t("profileAdministrationPrincipalView.btn.update.address")}
                                onClickArrowBtn={() => selectOtherView(t("profileAdministrationPrincipalView.btn.update.address"))}
                            // dataSetProp={"Inhabilitar empresa"}
                            />
                        </div>
                        <div className="profileAdministrationPrincipalView-arrow-btns">
                            <ArrowBtnHLPure
                                textArrowBtn={t("profileAdministrationPrincipalView.btn.change.password")}
                                onClickArrowBtn={() => selectOtherView(t("profileAdministrationPrincipalView.btn.change.password"))}
                            // dataSetProp={"Inhabilitar empresa"}
                            />
                        </div>
                        <ButtonHLPure
                            nameBtn={t("profileAdministrationPrincipalView.btn.update")}
                            primary={true}
                            onClickBtn={() => saveData()}
                        />
                    </div>
                </div>
            </Grid>
        </Container>
    )
}

export { ProfileAdministrationPrincipalView as default }